import React, { memo, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { AiProcessOwnerKind } from 'constants/aiProcessRuns';
import useCompanyId from 'hooks/useCompanyId';

import { buildAiActivityPath } from './AiActivity.url';
import AiActivityPanel from './AiActivityPanel';

const AiActivity = () => {
  const { applicationId, entityId } = useParams();
  const companyId = useCompanyId();

  const buildPath = useCallback(
    ({ executionId } = {}) => buildAiActivityPath({ applicationId, executionId }),
    [applicationId],
  );

  return (
    <AiActivityPanel
      buildPath={buildPath}
      companyId={companyId}
      executionId={entityId}
      ownerId={applicationId}
      ownerKind={AiProcessOwnerKind.LOAN_APPLICATION}
    />
  );
};

export default memo(AiActivity);
